import React from 'react';
import ContentLoader from 'react-content-loader';

const ContentLoading = props => <ContentLoader {...props} />;

export default ContentLoading;
